<template>
  <div>
    <div style="border-bottom: 4px solid #FAFAFA;padding: 0 20px 10px;margin-bottom: 4px">
        <div v-if="['all_order', 'in_transit', 'Refund&Return'].includes(orderStatus)" class="statusFilter">
            <div class="f" style="margin-bottom:20px;" v-if="['all_order'].includes(orderStatus)">
                <div style="color:#10141D;line-height:22px;margin-right:20px">Payment Status:</div>
                <template>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('waiting_payment')}" @click="statusFilterClick('waiting_payment', 'payment')">Waiting payment</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('paid')}" @click="statusFilterClick('paid', 'payment')">Paid</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('partial_refund')}" @click="statusFilterClick('partial_refund', 'payment')">Partial refund</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('refunding')}" @click="statusFilterClick('refunding', 'payment')">Refunding</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('refunded')}" @click="statusFilterClick('refunded', 'payment')">Refunded</div>
                </template>
            </div>
            <div class="f" style="margin-bottom:20px;" v-if="['Refund&Return'].includes(orderStatus)">
                <div style="color:#10141D;line-height:22px;margin-right:20px">Payment Status:</div>
                <template>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('refunded')}" @click="statusFilterClick('refunded', 'payment')">Refunded</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('partial_refund')}" @click="statusFilterClick('partial_refund', 'payment')">Partial Refund</div>
                </template>
            </div>
            <div class="f" style="margin-bottom:10px;" v-if="['all_order', 'in_transit'].includes(orderStatus)">
                <div style="color:#10141D;line-height:22px;margin-right:20px">Shipment Status:</div>
                <template v-if="orderStatus === 'all_order'">
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('waiting_to_ship')}" @click="statusFilterClick('waiting_to_ship', 'shipment')">Waiting to Ship</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('partial_shipped')}" @click="statusFilterClick('partial_shipped', 'shipment')">Partial Shipped</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('fully_shipped')}" @click="statusFilterClick('fully_shipped', 'shipment')">Fully Shipped</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('complete')}" @click="statusFilterClick('complete', 'shipment')">Complete</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('cancel')}" @click="statusFilterClick('cancel', 'shipment')">Cancel</div>
                </template>
                <template v-else-if="orderStatus === 'in_transit'">
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('fully_shipped')}" @click="statusFilterClick('fully_shipped', 'shipment')">Fully Shipped</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('partial_shipped')}" @click="statusFilterClick('partial_shipped', 'shipment')">Partial Shipped</div>
                </template>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import moment from 'moment'
// import BatchSearch from '@/components/BatchSearch.vue'
export default {
  props: {
    orderStatus: {
      type: String,
      default: 'all_order'
    }
  },
  data() {
    return {
      storeSelectList: [],
      paymentStatusSelected: [],
      shipmentStatusSelected: []
    }
  },
  methods: {
    resetPage() {
      this.searchParams.pageNumber = 1
      this.selectionForPayNow = []
      //   this.getList()
      this.$emit('getList', this.getParams())
    },
    getParams() {
      const params = Object.assign({}, this.searchParams, this.statusHandle())
      return params
    },
    statusHandle() {
      const financialStatus = []
      const refundStatus = []
      const fulfillmentStatus = []
      const status = []
      if (this.paymentStatusSelected.length) {
        switch (this.paymentStatusSelected[0]) {
          case 'waiting_payment':
            status.push('waiting_payment')
            break
          case 'paid':
          financialStatus.push('paid')
            break
          case 'partial_refund':
            refundStatus.push('partial_refund')
            break
          case 'refunding':
            refundStatus.push('refunding')
            break
          case 'refunded':
            refundStatus.push('refunded')
            break
          default:
            break
        }
      }
      if (this.shipmentStatusSelected.length) {
        switch (this.shipmentStatusSelected[0]) {
          case 'waiting_to_ship':
            fulfillmentStatus.push('waiting_to_ship')
            status.push('processing')
            break
          case 'partial_shipped':
            fulfillmentStatus.push('partial_shipped')
            break
          case 'fully_shipped':
            fulfillmentStatus.push('fully_shipped')
            break
          case 'complete':
            status.push('completed')
            break
          case 'cancel':
            status.push('cancel')
            break
          case 'in_transit':
            fulfillmentStatus.push('fully_shipped')
            fulfillmentStatus.push('partial_shipped')
            break
          default:
            break
        }
      }
      switch (this.orderStatus) {
        case 'all_order':

          break
        case 'waiting_payment':
          status.push('waiting_payment')
          break
        case 'waiting_to_ship':
          fulfillmentStatus.push('waiting_to_ship')
          status.push('processing')
          break
        case 'in_transit':
          if (!this.shipmentStatusSelected.length) {
            fulfillmentStatus.push('fully_shipped')
            fulfillmentStatus.push('partial_shipped')
          }
          break
        case 'Refund&Return':
          if (!this.paymentStatusSelected.length) {
            refundStatus.push('refunded')
            refundStatus.push('partial_refund')
          }
          break
        case 'order_info_missing':
          status.push('abnormal_order')
          break
        default:
          break
      }
      return {
        financialStatus: financialStatus,
        refundStatus: refundStatus,
        fulfillmentStatus: fulfillmentStatus,
        status: status
      }
    },
    statusFilterClick(value, way) {
      if (way === 'payment') {
        this.paymentStatusSelected = this.paymentStatusSelected.includes(value) ? [] : [value]
      }
      if (way === 'shipment') {
        this.shipmentStatusSelected = this.shipmentStatusSelected.includes(value) ? [] : [value]
      }
      this.$emit('getList', this.getParams())
    },
    statusFilterHandle() {

    }
  }
}
</script>

<style lang="scss" scoped>
.statusFilter{
    border-bottom: 4px;
    border-color: #8B93A3;
    margin-bottom: 10px;
    .active{
        color: #99C41C;
        background-color: rgba(153, 196, 28, 0.2);
    }
    .statusItem{
        line-height: 22px;
        margin-right: 22px;
        padding: 0 4px;
    }
}
</style>
